import { buildSearchFilterProps, sortStringColumn } from '../../../../../components/tables/utils'

export const buildIssuersTableColumns = () => [
  {
    title: 'Name',
    dataIndex: 'name',
    sorter: sortStringColumn({ dataIndex: 'name' }),
    ...buildSearchFilterProps({ dataIndex: 'name' }),
  },
  {
    title: 'Domain',
    dataIndex: 'domain',
    sorter: sortStringColumn({ dataIndex: 'domain' }),
    ...buildSearchFilterProps({ dataIndex: 'domain' }),
  },
  {
    title: 'Customer ID',
    dataIndex: 'customerId',
    sorter: sortStringColumn({ dataIndex: 'customerId' }),
    ...buildSearchFilterProps({ dataIndex: 'customerId' }),
  },
  {
    title: 'ANZSIC Code',
    dataIndex: 'anzsciCode',
    sorter: sortStringColumn({ dataIndex: 'anzsciCode' }),
    ...buildSearchFilterProps({ dataIndex: 'anzsciCode' }),
  },
  {
    title: 'Ratesheet',
    dataIndex: 'ratesheet',
    sorter: sortStringColumn({ dataIndex: 'ratesheet' }),
    ...buildSearchFilterProps({ dataIndex: 'ratesheet' }),
  },
]
